{
    "CX_Score_Licences_None": "Geen",
    "CX_Score_Licences_CXSScore": "Alleen CX-score",
    "CX_Score_Licences_CXSAgent": "CXS-agent",
    "CX_Score_Licences_CXSManager": "CXS-manager",
    "CX_Score_Agent_Error": "Voor een {} abonnement is een agent vereist.",
    "NAME": "CXScoreLanguage"
}